import React from 'react';
import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInbox } from '@fortawesome/pro-light-svg-icons/faInbox';
import { TypedMemo } from '../../../common/types';
import { SMLButton } from '../../../common/views/SMLButton/SMLButton';
import { useSMLRouter } from '../../../../routing/sml/hooks';
import { SMLRoutes } from '../../../../routing/sml/SMLRoutes';
import { outreachCampaignPath } from '../outreachPaths';
import { inboxMessages as messages } from './inboxMessages';
import { withBrandWord } from '../../components/primitives/BrandWord';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for Outreach; each part uses its own slice of it */
import styles from '../Outreach.module.scss';
/* eslint-enable css-modules/no-unused-class */

/**
 * Nothing needs you (design outreach-v2 m3): no reply yet. With a campaign filter the button opens
 * that campaign, else the Pitch page.
 */
const InboxEmptyComponent: React.FC<{ campaignUuid: string | null }> = ({ campaignUuid }) => {
  const intl = useIntl();
  const navigate = useNavigate();
  const router = useSMLRouter();
  const openCampaign = () => {
    if (campaignUuid === null) {
      router.push(SMLRoutes.outreach);
      return;
    }
    // eslint-disable-next-line no-void
    void navigate(outreachCampaignPath(campaignUuid));
  };
  return (
    <div className={styles.empty} data-testid="inbox-empty">
      <span className={styles.emptyIcon}>
        <FontAwesomeIcon icon={faInbox} />
      </span>
      <h3 className={styles.h2}>{intl.formatMessage(messages.emptyTitle)}</h3>
      <p className={styles.sub}>{withBrandWord(intl.formatMessage(messages.emptyBody))}</p>
      <SMLButton size="sm" outline omitCap onClick={openCampaign}>
        {intl.formatMessage(campaignUuid === null ? messages.emptyOpenPitch : messages.emptyOpenCampaign)}
      </SMLButton>
    </div>
  );
};

export const InboxEmpty = TypedMemo(InboxEmptyComponent);
